import type { CommunitySwitcher } from "@circle-react/types/CommunitySwitcher";
import { useEffect, useState } from "react";

import { requestNotificationCountForCommunity } from "./utils";

export const useSwitcherNotificationCounts = () => {
  const [notificationCounts, setNotificationCounts] = useState<
    Record<number, number>
  >({});
  const [communitiesNeedingCounts, setCommunitiesNeedingCounts] = useState<
    CommunitySwitcher[]
  >([]);

  useEffect(() => {
    for (const community of communitiesNeedingCounts) {
      requestNotificationCountForCommunity(community, setNotificationCounts);
    }
  }, [communitiesNeedingCounts]);

  return { notificationCounts, setCommunitiesNeedingCounts };
};
